import React from 'react'

type Props = {
  condition: boolean
  wrapper: (arg0: React.ReactNode) => React.ReactNode
  otherwise?: (arg0: React.ReactNode) => React.ReactNode
  children: React.ReactNode
}

const ConditionalWrapper = ({ condition, wrapper, otherwise, children }: Props) => {
  return <>{condition ? wrapper(children) : otherwise ? otherwise(children) : children}</>
}

export default ConditionalWrapper
